<template>
<div>
  <v-row>
    <page-title value="午睡テンプレート"></page-title>
    <v-spacer />
    <v-btn  color="primary" variant="flat">
      <v-icon start>mdi-plus</v-icon>
      新規作成
    </v-btn>
  </v-row>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'

export default defineComponent({
  name: 'NapTemplateList',

  components: {
    PageTitle
  },
})
</script>